/*Copyright (c) 2025 por Tecnologías de Información MALMUR y empresas afiliadas. Todos los derechos reservados.
Este software es información confidencial y propietaria de Copyright (c) 2025 por Tecnologías de Información MALMUR
 y sus afiliadas. ("Información Confidencial"). Usted no puede divulgar dicha Información Confidencial, 
 y solo puede usar dicha Información Confidencial de acuerdo con los términos del acuerdo de licencia que celebró con MALMUR.*/

/*Copyright (c) 2025 by Tecnologías de Información MALMUR and affiliated companies. All Rights Reserved.
This software is confidential and proprietary information of Copyright (c) 2025 by Tecnologías de Información 
MALMUR and its affiliates. ("Confidential Information"). You may not disclose such Confidential Information, 
and may only use such Confidential Information in accordance with the terms of the license agreement you entered 
into with MALMUR.*/



import TemplateDataContent from "components/content/TemplateDataContent";
import DefaultDashboardLayout from "layouts/dashboard/DefaultDashboardLayout";
import { FC } from "react";

/**
 * Clinical documentation template management page.
 * 
 * Features:
 * - Library of clinical note templates
 * - Template creation and customization
 * - SOAP note templates
 * - Specialty-specific documentation templates
 * - Template versioning and approval workflow
 * - Integration with progress notes and office visits
 * 
 * @returns Templates management page component
 */
const TemplatesPage: FC = () => {
  return (
    <DefaultDashboardLayout>
      <TemplateDataContent />
    </DefaultDashboardLayout>
  );
};

export default TemplatesPage;

